<template>
  <div>
    <div :class="openMenu ? 'sideNav' : 'hideSideNav'">
      <div
        class="sideNav-header"
        :class="openMenu ? '' : 'sideNav-header-close'"
      >
        <div
          :class="openMenu ? 'hamburger' : 'hamburger hamburger-closed'"
          @click="toggleMenu()"
          id="btn-hamburger"
        >
          <BaseIcon name="hamburger" width="1.2rem" height="1.2rem" />
        </div>
        <div v-if="openMenu && !hideBrandName" class="r-logo">
          <BaseIcon name="rakutenTextLogo" width="12.5rem" height="4rem" />
        </div>
        <div v-if="openMenu && hideBrandName" class="r-logo hide-brand-name">
          {{ getEnv('VUE_APP_IS_WHITE_LABEL') }}
        </div>
      </div>
      <div class="sideNav-body">
        <div class="user-card">
          <TenantField v-if="openMenu" />
          <div class="nav-items">
            <div
              class="navs"
              v-for="(item, index) in getNavItems"
              :key="index"
              :id="`side-nav-${item.path}`"
            >
              <router-link
                active-class="active"
                :to="{ name: item.path }"
                :class="['router', { 'disable-nav-item': item.disabled }]"
              >
                <span class="icon" :class="item.isBeta && 'icon_with_beta'">
                  <BaseIcon
                    :name="item.icon"
                    width="1.1875rem"
                    height="1.125rem"
                    :class="[{ 'disable-nav-item': item.disabled }]"
                  />
                </span>
                <span class="headings">
                  {{ item.name }}
                  <BaseIcon
                    :name="item.subIcon"
                    width="1rem"
                    height="1rem"
                    :class="[
                      'nav-sub-icon',
                      { 'disable-nav-item': item.disabled },
                    ]"
                  />
                </span>
                <span v-if="item.isBeta" class="nav-beta-icon">
BETA
</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="logout-div">
        <div
          class="side-bar-user-info-box"
          :class="!openMenu && 'side-bar-closed-user-info-box'"
        >
          <RexAvatarV3 size="default">
            {{ getFirstLetter }}
          </RexAvatarV3>
          <div v-if="openMenu" class="side-bar-user-info">
            <RexTypographyV3
              type="text"
              :level="2"
              :ellipsis="true"
              :content="`${getFirstName} ${getLastName}`"
            />
            <RexTypographyV3
              type="text"
              :level="1"
              :ellipsis="true"
              :content="`${getEmail}`"
              class="side-bar-email-text"
            />
          </div>
        </div>
        <div class="logout" @click="logoutUser" id="btn-logout-user">
          <span>
            <BaseIcon name="logout" width="1.875rem" height="1.25rem" />
          </span>
          <div class="logout-text">
            {{ $t('logOut') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseIcon from '../../rex-components/BaseIcon.vue';
import RexAvatarV3 from '@/rex-components/RexAvatarV3.vue';
import RexTypographyV3 from '@/rex-components/RexTypographyV3.vue';
import TenantField from '@/components/Main/Tenant/TenantField.vue';
import { mapMutations, mapState, mapGetters } from 'vuex';
import { AuthService } from '@/services/api/auth.service';
import { navItems } from '@/utils/enums/navItems';
import BuildConfig from '@/environment';
import getEnv from '@/utils/env';
import {
  TEMPLATE_HOME,
  TEMPLATE_NOTIFICATION,
  TEMPLATE_APM,
  TEMPLATE_ALERT,
  TEMPLATE_ALERTS_V2,
  TEMPLATE_BROWSER,
  TEMPLATE_SETTINGS,
  TEMPLATE_VM,
  TEMPLATE_HELP,
  TEMPLATE_MOBILE,
  TEMPLATE_DATABASE,
  TEMPLATE_WSM,
  TEMPLATE_SM,
  TEMPLATE_K8M,
  TEMPLATE_INTEGRATIONS,
  TEMPLATE_CLOUD_SVC,
  TEMPLATE_LOG,
  TEMPLATE_ANALYTICS,
  TEMPLATE_DE,
  TEMPLATE_BILLING_USAGE,
  TEMPLATE_MQ,
} from '@/utils/constants';
import { usePermissions } from '@/hooks/usePermissions';

export default {
  components: { BaseIcon, TenantField, RexAvatarV3, RexTypographyV3 },
  props: {},
  data: function () {
    return {
      count: 0,
      navItems: [],
      activeCapabilities: [],
      navItemsArray: [],
    };
  },
  computed: {
    ...mapState('globalState/app', ['openMenu']),
    ...mapGetters('globalState/user', {
      userInfoGetter: 'getUserInfo',
    }),

    getFirstName() {
      return this.userInfoGetter.firstName || '';
    },
    getLastName() {
      return this.userInfoGetter.lastname || '';
    },
    getFirstLetter() {
      return this.getFirstName ? this.getFirstName.charAt(0) : 'R';
    },
    getEmail() {
      return this.userInfoGetter.email || '';
    },
    hideBrandName() {
      return BuildConfig.VUE_APP_DISABLE_ICON === 'true';
    },
    getNavItems() {
      const { hasCapabilityPermissionByRoute } = usePermissions();
      return [
        {
          name: this.$t('home'),
          path: navItems.HOME,
          templateName: TEMPLATE_HOME,
          icon: navItems.HOME,
          hide: false,
        },
        // {
        //   name: this.$t('alerts'),
        //   path: navItems.ALERT,
        //   templateName: TEMPLATE_ALERT,
        //   icon: navItems.ALERT,
        //   hide: true,
        // },

        {
          name:
            this.$t('alerts') +
            (!BuildConfig.VUE_APP_ALERT_V2_ENABLE ? ' V2' : ''),
          path: navItems.ALERTSV2,
          templateName: TEMPLATE_ALERTS_V2,
          icon: navItems.ALERT,
          hide: false,
        },
        {
          name: this.$t('notificationChannels'),
          path: navItems.NOTIFICATION,
          templateName: TEMPLATE_NOTIFICATION,
          icon: navItems.NOTIFICATION,
          hide: false,
        },
        {
          name: this.$t('apmLabel'),
          path: navItems.APM,
          templateName: TEMPLATE_APM,
          icon: navItems.APM,
          subIcon: 'starFilled',
          hide: this.showNavBarItem(navItems.APM),
        },
        {
          name: this.$t('browserMonitoring'),
          path: navItems.BROWSER,
          templateName: TEMPLATE_BROWSER,
          icon: navItems.BROWSER,
          subIcon: 'starFilled',
          hide: this.showNavBarItem(navItems.BROWSER),
        },
        {
          name: this.$t('syntheticMonitoring'),
          path: navItems.SM,
          templateName: TEMPLATE_SM,
          icon: navItems.SM,
          hide: this.showNavBarItem(navItems.SM),
        },
        {
          name: this.$t('databaseMonitoring'),
          path: navItems.DATABASE,
          templateName: TEMPLATE_DATABASE,
          icon: navItems.DATABASE,
          hide: this.showNavBarItem(navItems.DATABASE),
        },
        {
          name: this.$t('mq.mqMonitoring'),
          path: navItems.MQ,
          templateName: TEMPLATE_MQ,
          icon: navItems.MQ,
          hide: this.showNavBarItem(navItems.MQ),
        },
        {
          name: this.$t('vmMonitoring'),
          path: navItems.VM,
          templateName: TEMPLATE_VM,
          icon: navItems.VM,
          subIcon: 'starFilled',
          hide: this.showNavBarItem(navItems.VM),
        },
        {
          name: this.$t('mobileMonitoring'),
          path: navItems.MOBILE,
          templateName: TEMPLATE_MOBILE,
          icon: navItems.MOBILE,
          subIcon: 'starFilled',
          hide: this.showNavBarItem(navItems.MOBILE),
        },

        // {
        //   name: this.$t('webServerMonitoring'),
        //   path: navItems.WSM,
        //   templateName: TEMPLATE_WSM,
        //   icon: navItems.WSM,
        //   hide: true,
        // },
        {
          name: this.$t('k8m'),
          path: navItems.K8M,
          templateName: TEMPLATE_K8M,
          icon: navItems.K8M,
          subIcon: 'starFilled',
          hide: this.showNavBarItem(navItems.K8M),
        },
        {
          name: this.$t('integrations'),
          path: navItems.INTEGRATIONS,
          templateName: TEMPLATE_INTEGRATIONS,
          icon: navItems.INTEGRATIONS,
          hide: this.showNavBarItem(navItems.INTEGRATIONS),
        },
        {
          name: this.$t('cloudSvc'),
          path: navItems.CLOUD,
          templateName: TEMPLATE_CLOUD_SVC,
          icon: navItems.CLOUD,
          hide: this.showNavBarItem(navItems.CLOUD),
        },
        {
          name: this.$t('log.logMonitoring'),
          path: navItems.LOG,
          templateName: TEMPLATE_LOG,
          icon: navItems.LOG,
          hide: this.showNavBarItem(navItems.LOG),
          isBeta: false,
        },
        {
          name: this.$t('analytics.analytics'),
          path: navItems.ANALYTICS,
          templateName: TEMPLATE_ANALYTICS,
          icon: navItems.ANALYTICS,
          hide: this.showNavBarItem(navItems.ANALYTICS),
          isBeta: false,
        },
        {
          name: this.$t('digitalExperience'),
          path: navItems.DE,
          templateName: TEMPLATE_DE,
          icon: navItems.DE,
          hide: this.showNavBarItem(navItems.DE),
        },
        {
          name: this.$t('usage.billingUsage'),
          path: navItems.BILLING,
          templateName: TEMPLATE_BILLING_USAGE,
          icon: 'billingUsage',
          hide: this.showNavBarItem(navItems.BILLING),
        },
        {
          name: this.$t('settings'),
          path: navItems.SETTINGS,
          templateName: TEMPLATE_SETTINGS,
          icon: navItems.SETTINGS,
          hide: false,
        },
      ].map((navItem) => {
        return {
          ...navItem,
          disabled: !hasCapabilityPermissionByRoute(navItem.path),
        };
      });
    },
  },
  methods: {
    ...mapMutations('globalState/app', ['setTemplate']),
    ...mapMutations('globalState/app', ['toggleMenu', 'setTemplate']),
    ...mapMutations('globalState/app', ['setActiveCapabilities']),
    getEnv,
    setCurrentName(routerName) {
      switch (routerName) {
        case 'service':
          this.setTemplate(TEMPLATE_APM);
          break;
        case 'home':
          this.setTemplate(TEMPLATE_HOME);
          break;
        case 'configured':
          this.setTemplate(TEMPLATE_ALERT);
          break;
        case 'notification':
          this.setTemplate(TEMPLATE_NOTIFICATION);
          break;
        case 'application':
          this.setTemplate(TEMPLATE_BROWSER);
          break;
        case 'database':
          this.setTemplate(TEMPLATE_DATABASE);
          break;
        case 'vm':
          this.setTemplate(TEMPLATE_VM);
          break;
        case 'settings':
          this.setTemplate(TEMPLATE_SETTINGS);
          break;
        case 'mobile':
          this.setTemplate(TEMPLATE_MOBILE);
          break;
        case 'sm':
          this.setTemplate(TEMPLATE_SM);
          break;
        case 'help':
          this.setTemplate(TEMPLATE_HELP);
          break;
        case 'wsm':
          this.setTemplate(TEMPLATE_WSM);
          break;
        case 'digitalExperience':
          this.setTemplate(TEMPLATE_DE);
          break;
        case 'billingUsage':
          this.setTemplate(TEMPLATE_BILLING_USAGE);
          break;
        default:
          break;
      }
    },
    logoutUser() {
      AuthService.makeLogout();
    },
    populateNavBarItems() {
      this.navItemsArray.map((item, index) => {
        if (!item.hide) {
          this.navItems.push(item);
        }
      });
    },
    getActiveCapabilities() {
      const activeFeatures =
        BuildConfig.VUE_APP_ACTIVE_CAPABILITIES ||
        process.env.VUE_APP_ACTIVE_CAPABILITIES ||
        '';
      this.activeCapabilities = activeFeatures.split(',');
      this.setActiveCapabilities(this.activeCapabilities);
    },
    showNavBarItem(item) {
      if (this.activeCapabilities == '') return false; //return all capabilites if there's no feature flag in env
      if (item === navItems.CLOUD || item === navItems.INTEGRATIONS) {
        return ![navItems.CLOUD, navItems.INTEGRATIONS].some((capability) =>
          this.activeCapabilities.includes(capability),
        );
      }

      return !this.activeCapabilities?.includes(item); //returns hide as false if it's active capability, else return true
    },
  },
  mounted() {
    this.getActiveCapabilities();
    // this.populateNavItemsArray();
    this.setCurrentName(this.$route.name);
    // this.populateNavBarItems();
  },
};
</script>
<style lang="scss" scoped>
.sideNav-header {
  // color: $color-brand-accent;
  text-align: left;
  @include flex-center-justify;
  align-items: baseline;
  margin-right: 3rem;
  .hamburger {
    // @include svg-fill-pointer($font-primary);
    //margin-left: 0.625rem;
    fill: $color-brand-accent;
    cursor: pointer;
    margin-top: 1rem;
  }
  .r-logo {
    margin-left: 1.25rem;
    margin-top: 1.5rem;
  }
}
.sideNav-header-close {
  align-items: center;
  margin-right: 0rem;
}
.sideNav-body {
  margin-top: 2rem;
}

.sideNav {
  height: 100vh;
  width: 20rem;
  background-color: $bg-secondary;
  min-height: 40rem;
  @include flex-column;
  @include dropshadow-effect;
  position: fixed;
  transition: width 0.5s;
}
.hideSideNav {
  height: 100vh;
  width: 6.1875rem;
  background-color: $bg-secondary;
  @include flex-column;
  @include dropshadow-effect;
  min-height: 40rem;
  position: fixed;
  transition: width 0.5s;
  .router {
    @include flex-center-justify;
    align-items: flex-start;
    text-decoration: none;
    color: $color-brand-accent;
    margin-bottom: 1.25rem;
    height: 2.5rem;
    align-items: center;
    width: 5.0625rem;
  }
  .headings {
    display: none;
  }
  .email {
    display: none;
  }
  .userinfo {
    display: none;
  }
  .ellipseClass svg {
    height: 3.9375rem;
    width: 3.9375rem;
  }
  .icon_with_beta {
    width: fit-content !important;
  }
}
.user-card {
  margin-top: -0.75rem;
  margin-bottom: 0.625rem;
  @include flex-center-column;
  color: $font-primary;
}
.userinfo {
  width: 10.5625rem;
  color: $color-brand-accent;
  font-size: 1.5rem;
  // line-height: 1.875rem;
  margin-top: 0.75rem;
  margin-bottom: 1rem;
}
.brand-name {
  width: 12.625rem;
  font-size: 1.5rem;
  fill: $font-primary;
  .brand-name-bottom {
    border-bottom: 1px solid $border-primary;
    margin-top: 0.8125rem;
  }
}
.nav-items {
  margin-top: 0.625rem;
  overflow-y: scroll;
  overflow-x: auto;
  max-height: calc(100vh - 28rem);
}
.email {
  widows: 10.5625rem;
  font-family: $semi-bold;
  line-height: 1.25rem;
  font-size: 1rem;
  margin-bottom: 2.3125rem;
  color: $font-secondary;
}

.router {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  text-decoration: none;
  color: $color-brand-accent;
  margin-bottom: 0.5rem;
  height: 2.5rem;
  width: 19.3rem;
  font-family: $semi-bold;
  @include svg-fill($color-brand-accent);
  .icon {
    //margin-right: 1.6875rem;
    //margin-left: 1.9375rem;
    // align-content: left;
    width: 3rem;
    line-height: 50%;
  }
  .heading {
    margin-left: 1.5625rem;
  }
  &:hover {
    border-radius: 1.0625rem;
    border: 1px solid $color-brand-accent;
    @include dropshadow-effect(0.16);
  }
}
.nav-beta-icon {
  font-size: 0.625rem;
  font-weight: 600;
  border-radius: 0.25rem;
  background-color: $color-white;
  padding: 0.188rem 0.25rem;
  color: $color-black;
  height: 1.125rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 0.5rem;
}
.hide-brand-name {
  text-align: center;
  width: 12rem;
  overflow: hidden;
  align-self: flex-start;
  margin-right: 2rem;
}
.active {
  background-color: $bg-tertiary !important;
  cursor: pointer;
  color: $font-primary !important;
  border-radius: 1.0625rem;
  width: 19.6rem;
  font-family: $semi-bold;
  @include dropshadow-effect(0.16);
  .icon {
    @include svg-fill-pointer($font-primary);
  }
  .headings {
    color: $font-primary !important;
  }
}
.logout-div {
  margin-top: auto;
  margin-bottom: 1.5rem;
  .logout {
    @include svg-fill-pointer($color-brand-accent);
    &:hover {
      cursor: pointer;
    }
  }
  .logout-text {
    margin-top: 0.625rem;
    color: $color-brand-accent;
  }
}
.nav-sub-icon {
  margin-right: 0.5em;
  @include svg-fill($color-active-blue);
  vertical-align: super;
}
.side-bar-user-info-box {
  @include flex-center-vert;
  text-align: left;
  margin-left: 0.5rem;
  border-bottom: solid 0.0625em $border-primary;
  padding-bottom: 1rem;
  margin-bottom: 1rem;
}
.side-bar-user-info {
  width: 100%;
  margin-left: 0.5rem;
  width: 12.5rem;
}
.side-bar-closed-user-info-box {
  @include flex-center-justify;
}

.disable-nav-item {
  pointer-events: none;
  color: gray;
  cursor: not-allowed;
  fill: gray;

  :deep(.fillStroke) {
    stroke: gray;
  }

  :deep(.fillPath) {
    fill: gray;
  }
}
</style>
